import React, { FC, useState } from 'react';
import { toast } from 'react-toastify';
import {
  GxForm,
  GxButton,
  GxSpinner,
} from '@garpix/garpix-web-components-react';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import { useStoreon } from 'storeon/react';
import Select from '@/components/Select'
import { Events, State } from '@/interfaces';
import { colourStyles } from '@/apps/FlyingList/components/TableItem/styles/select';
import ModalLayout from '../../../../components/ModalLayout';
import { IModalInvoice } from './interfaces';

import styles from './styles/index.module.scss';

export const ModalEntryChange: FC<IModalInvoice> = ({ props, flag, onRequestClose }) => {
  const { entry_time, onChangeEntryTime } = props;
  const [statusLoad, setStatusLoad] = useState(false);

  const {
    instructorOptions
  } = useStoreon<State, Events>(
    'instructorOptions'
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      entry_time: entry_time || dayjs().format('HH:mm'),
      instructor_id: undefined,
      controller_id: undefined,
      instructor_selected: false,
      controller_selected: false
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async ({ entry_time, instructor_selected, controller_selected }) => {
      setStatusLoad(true);
      try {
        const instructor = !instructor_selected ? formik.values.instructor_id : undefined;
        const controller = !controller_selected ? formik.values.controller_id : undefined;
        onChangeEntryTime({ entry_time, instructor, controller });
      } catch {
        toast.error('Не удалось изменить данные входа')
      } finally {
        onRequestClose();
        setStatusLoad(false);
      }
    }
  })

  const instructorIsInvalid = formik.values.instructor_id === undefined && formik.values.instructor_selected === false;
  const controllerIsInvalid = formik.values.controller_id === undefined && formik.values.controller_selected === false;

  const handleChangeSelect = ({e,key, value}: {e:React.ChangeEvent<HTMLInputElement>, key: 'instructor_selected' | 'controller_selected', value: any}) => {
    formik.setFieldValue(key, value);

    if(e.target.checked) {
      const optionKey = key === 'instructor_selected' ? 'instructor_id' : 'controller_id';
      formik.setFieldValue(optionKey, null)
    }
  }

  return (
    <ModalLayout
      size='sm'
      flag={flag}
      onClose={onRequestClose}
    >
      <div className={styles['header']}>
        <h2 className={styles['header--title']}>Время входа</h2>
      </div>
      <GxForm onGx-submit={formik.submitForm}>
        <div className={styles['main']}>
          <input
            type='time'
            name='entry_time'
            className={styles['time']}
            onChange={(e) => formik.setFieldValue('entry_time', e.target.value)}
            defaultValue={formik.values.entry_time}
          />
        </div>

        <div className={styles['instructor']}>
          <span>Инструктор</span>
          <div className={styles['instructor--container']}>
            <Select
              styles={colourStyles}
              menuPosition='fixed'
              options={instructorOptions}
              onChange={(newOption) => formik.setFieldValue('instructor_id', newOption?.value)}
              isDisabled={formik.values.instructor_selected}
            />
          </div>
          <input
            type="checkbox"
            name="instructor_selected"
            onChange={(e) => handleChangeSelect({e, key: 'instructor_selected', value: e.target.checked})}
            checked={formik.values.instructor_selected}
            className={styles.checkbox}
          />
        </div>
        <div className={styles['controller']}>
          <span>Контроллер</span>
          <div className={styles['controller--container']}>
            <Select
              styles={colourStyles}
              menuPosition='fixed'
              options={instructorOptions}
              onChange={(newOption) => formik.setFieldValue('controller_id', newOption?.value)}
              isDisabled={formik.values.controller_selected}
            />
          </div>
          <input
            type="checkbox"
            name="controller_selected"
            onChange={(e) => handleChangeSelect({e,key: 'controller_selected', value: e.target.checked})}
            checked={formik.values.controller_selected}
            className={styles.checkbox}
          />
        </div>
        <div className={styles['footer']}>
          <div className={styles['footer--container']}>
            <GxButton type="button" className={styles['btn--close']} onClick={onRequestClose}>Отмена</GxButton>
            {statusLoad
              ? <GxSpinner style={{ fontSize: '2rem' }} />
              : <GxButton className={styles['btn--save']} type="submit" disabled={instructorIsInvalid || controllerIsInvalid}>Сохранить</GxButton>
            }
          </div>
        </div>
      </GxForm>

    </ModalLayout>
  );
};
